export const LawyerSpecializations = [
  { value: "", label: "Select Specialization" },
  { value: "property lawyer", label: "Property Lawyer" },
  { value: "family lawyer", label: "Family Lawyer" },
  { value: "civil lawyer", label: "Civil Lawyer" },
  { value: "cyber lawyer", label: "Cyber Lawyer" },
  { value: "criminal lawyer", label: "Criminal Lawyer" },
  { value: "consumer lawyer", label: "Consumer Lawyer" },
  { value: "labour lawyer", label: "Labour Lawyer" },
  {
    value: "company law & corporate compliance",
    label: "Company Law & Corporate Compliance",
  },
];

export const LawyerStates = [
  { value: "", label: "All States" },

  // States
  { value: "andhra-pradesh", label: "Andhra Pradesh" },
  { value: "arunachal-pradesh", label: "Arunachal Pradesh" },
  { value: "assam", label: "Assam" },
  { value: "bihar", label: "Bihar" },
  { value: "chhattisgarh", label: "Chhattisgarh" },
  { value: "goa", label: "Goa" },
  { value: "gujarat", label: "Gujarat" },
  { value: "haryana", label: "Haryana" },
  { value: "himachal-pradesh", label: "Himachal Pradesh" },
  { value: "jharkhand", label: "Jharkhand" },
  { value: "karnataka", label: "Karnataka" },
  { value: "kerala", label: "Kerala" },
  { value: "madhya-pradesh", label: "Madhya Pradesh" },
  { value: "maharashtra", label: "Maharashtra" },
  { value: "manipur", label: "Manipur" },
  { value: "meghalaya", label: "Meghalaya" },
  { value: "mizoram", label: "Mizoram" },
  { value: "nagaland", label: "Nagaland" },
  { value: "odisha", label: "Odisha" },
  { value: "punjab", label: "Punjab" },
  { value: "rajasthan", label: "Rajasthan" },
  { value: "sikkim", label: "Sikkim" },
  { value: "tamil-nadu", label: "Tamil Nadu" },
  { value: "telangana", label: "Telangana" },
  { value: "tripura", label: "Tripura" },
  { value: "uttar-pradesh", label: "Uttar Pradesh" },
  { value: "uttarakhand", label: "Uttarakhand" },
  { value: "west-bengal", label: "West Bengal" },

  // Union Territories
  { value: "andaman-nicobar", label: "Andaman and Nicobar Islands" },
  { value: "chandigarh", label: "Chandigarh" },
  {
    value: "dadra-nagar-haveli-daman-diu",
    label: "Dadra and Nagar Haveli and Daman and Diu",
  },
  { value: "delhi", label: "Delhi" },
  { value: "jammu-kashmir", label: "Jammu and Kashmir" },
  { value: "ladakh", label: "Ladakh" },
  { value: "lakshadweep", label: "Lakshadweep" },
  { value: "puducherry", label: "Puducherry" },
];

export const LawyerPracticingCourts = [
  { value: "", label: "Select Practicing Court" },
  { value: "other", label: "Other" },
  { value: "tis_hazari_court", label: "Tis Hazari Court" },
  { value: "saket_court", label: "Saket Court" },
  { value: "karkardooma_court", label: "Karkardooma Court" },
  { value: "patiala_house_court", label: "Patiala House Court" },
  { value: "rohini_court", label: "Rohini Court" },
  { value: "dwarka_court", label: "Dwarka Court" },
  { value: "rouse_avenue_court", label: "Rouse Avenue Court" },
  { value: "high_court", label: "High Court" },
];

export const LawyerLanguages = [
  { value: "", label: "Select Language" },
  { value: "english", label: "English" },
  { value: "hindi", label: "Hindi" },
  { value: "marathi", label: "Marathi" },
  { value: "tamil", label: "Tamil" },
  { value: "telugu", label: "Telugu" },
  { value: "kannada", label: "Kannada" },
  { value: "malayalam", label: "Malayalam" },
  { value: "bengali", label: "Bengali" },
  { value: "gujarati", label: "Gujarati" },
  { value: "punjabi", label: "Punjabi" },
  { value: "urdu", label: "Urdu" },
  { value: "odia", label: "Odia" },
  { value: "assamese", label: "Assamese" },
];

export const UserRoles = Object.freeze({
  CUSTOMER: "customer",
  LAWYER: "lawyer",
  ADMIN: "admin",
});